import { ProfileInitialRepository } from 'src/app/features/private/profile/state/profile-initial.repository';
import { Component, inject }  from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-bottom-sheet-mobile',
  templateUrl: './bottom-sheet-mobile.component.html',
  styleUrls: ['./bottom-sheet-mobile.component.scss'],
  imports: [
    CommonModule,
    MatIconModule,
    RouterModule,
    MatButtonModule,
  ],
})
export class BottomSheetMobileComponent {
  private _profileInitialRepo = inject(ProfileInitialRepository);
  role$ = this._profileInitialRepo.role$;

  private _router = inject(Router);

  constructor() { }

  ngOnInit() {
  }
}
